import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { COMMUNUCATE_OPTIONS } from './constants';

export const ScreenCommunicate: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Communicate',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const communicate = form.watch('communicate');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['communicate']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        communicate: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>How do you prefer her to communicate?</OwnAiTitle>
        <OnboardingOptionsList>
          {COMMUNUCATE_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={communicate === option.id}
              control={form.control}
              option={option}
              name="communicate"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`communicate-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
